import { FC, useMemo, useState } from 'react';

import { AwardingBodyIdentifiers } from 'core';
import { BasketItem } from 'store/basket/basketAPI';
import { CandidateProductDetails } from 'store/candidate/types';

import { FormFields } from '@britishcouncil/react-forms';
import { Divider, LinkButton, RadioGroup, TextField } from '@britishcouncil/react-solas-ors3';

import { ExamCard, UciInformationModal } from '.';

export const CandidateExams: FC<{
  exams: BasketItem[];
  fields: FormFields<CandidateProductDetails>;
  awardingBodyId: number | undefined;
  canEditUci: boolean;
}> = ({ exams, fields, awardingBodyId, canEditUci }) => {
  const [showModal, setModal] = useState(false);
  const showUciNumberForm = useMemo(
    () => awardingBodyId === AwardingBodyIdentifiers.Edexcel || awardingBodyId === AwardingBodyIdentifiers.AQA,
    [awardingBodyId]
  );
  console.log('CandidateExams rendered with exams:', exams);
  return (
    <>
      <h2>Candidate exams</h2>
      {showUciNumberForm && (
        <>
          <label>
            Have you already sat for the session and have UCI number? (
            <LinkButton onClick={() => setModal(true)}>more info</LinkButton>)
          </label>
          <RadioGroup
            radios={[
              { label: 'Yes', checkValue: 'true' },
              { label: 'No', checkValue: 'false' },
            ]}
            {...fields.forceSetUciNumber}
            value={`${fields.forceSetUciNumber.value}`}
            onChange={(val) => fields.forceSetUciNumber.onChange(val === 'true')}
            disabled={!canEditUci}
          />
          {fields.forceSetUciNumber.value && (
             <TextField {...fields.uci} label="Unique candidate's identifier (if applicable)*" disabled={!canEditUci} showColon={false}/>
          )}
          <Divider />
          <UciInformationModal show={showModal} onExit={() => setModal(false)} />
        </>
      )}
      {exams.map((item, i) => (
        <ExamCard
          item={item}
          fields={fields.examRetake[i]}
          awardingBodyId={awardingBodyId}
          key={i}
        />
      ))}
      <Divider />
    </>
  );
};
